import { BiLockOpenAlt } from "react-icons/bi"; 
import { BiLockAlt } from "react-icons/bi"; 
import { BiDotsVerticalRounded, } from "react-icons/bi";
import { FaFilePrescription } from "react-icons/fa"; 
import React from 'react';
import GxList from '../../gx/GxList';
import CxDlgTable from '../../cx/CxDlgTable';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxDialog from '../../cx/CxDialog';
import CxDate from '../../cx/CxDate';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import * as FxStr from '../../fx/FxStr';
import * as FxRegion from '../../fx/FxRegion';
import * as FxFetch from '../../fx/FxFetch';
import * as FxFile from '../../fx/FxFile';
import { useNav } from '../../hx/useNav';
import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreClient, StoreRxAuto } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxDlgSelectClient from '../../gx/GxDlgSelectClient';
import * as MxAnimalRxAutoFormH1 from '../files/MxAnimalRxAutoFormH1';
import GxIconButtonLastClient from '../../gx/GxIconButtonLastClient';
import CxDlgAlert from '../../cx/CxDlgAlert';
import CxButtonMenu from '../../cx/CxButtonMenu';


const MxActivityVettR = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const size = useWindowSize();
  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);
  const [storeRxAuto, setStoreRxAuto] = useSessionStorage('StoreRxAuto', StoreRxAuto);
  
  const [lockOps, setLockedOps] = React.useState(true);
  
  const r_dlg_alert = React.useRef(null);
  
  const r_list = React.useRef(null);
  let refColors = [];
  const r_dlg_select_client = React.useRef(null);
  const r_dlgtable_rxs_invoice = React.useRef(null);

  const hasColumnSpecies = () => { return Boolean(localStorage.getItem('MxActivityVettR.addcol_txTypeAnimalSpecies') === '1') };
  const hasColumnBreed = () => { return Boolean(localStorage.getItem('MxActivityVettR.addcol_txTypeAnimalBreed') === '1') };
  const hasColumnSeries = () => { return Boolean(localStorage.getItem('MxActivityVettR.addcol_txTypeSeriesRx') === '1') };
  const hasColumnEmployee = () => { return Boolean(localStorage.getItem('MxActivityVettR.addcol_txEmployee') === '1') };
  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxActivityVettR.addcol_txBranchId') === '1') };

  const rf_create_recevet_from = React.useRef(null);
  const rf_create_recevet_to = React.useRef(null);

  const [dlgRxsInvoice, setDlgRxsInvoice] = React.useState(false);
  const [dlgCreateRecevetFile, setDlgCreateRecevetFile] = React.useState(false);

  React.useEffect(() => {
    clearStore('StoreRxAuto', storeRxAuto);

    refColors.push('table_cell_black|' + trans('field.manual'));
    refColors.push('table_cell_color_green|' + trans('field.automatic_0'));
    if (FxRegion.isSpain() && !FxRegion.isAndalusia()) {
      refColors.push('table_cell_color_gray|Presvet - En proceso');
      refColors.push('table_cell_color_brown|Presvet - Error');
    }

    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {
    if (row === null) {
      let iv = {};
      iv = { txType: op.split(':')[1], _id: null, txRxAuto: null, itSeriesRx: null };
      r_dlg_select_client.current.setIntermediateValues(iv);
      r_dlg_select_client.current.setOpen(true);
    } else {
      FxLog.infox('MxActivityVettR.openForm', '...row.original:', row.original);
      storeClient.inClient = row.original.inClient;
      storeClient.txClient = row.original.txClient;
      storeClient.inAnimal = row.original.animal_inAnimal;
      storeClient.txAnimal = row.original.animal_txAnimal;

      storeRxAuto.inClient = row.original.inClient;
      storeRxAuto.inAnimal = row.original.animal_inAnimal;
      storeRxAuto.txClient = row.original.txClient;
      storeRxAuto.txAnimal = row.original.animal_txAnimal;

      storeRxAuto.boFirstRender = true;
      storeRxAuto.boDataChanged = '0';
      storeRxAuto.boAuto = Boolean(row.original.inInvoice);

      if (row.original.txType === 'A') {
        storeRxAuto.txRxAuto = null;
        storeRxAuto.itSeriesRx = null;
        storeRxAuto.inInvoice = null;
      } else {
        storeRxAuto.inRxAuto = row.original._id;
        storeRxAuto.txRxAuto = row.original.txRxAuto;
        storeRxAuto.itSeriesRx = row.original.itSeriesRx;
      }

      Promise.all([setStoreClient(storeClient)]).then((result) => {
        //FxLog.infox('MxActivityVettR.openForm', '...storeClient:', storeClient);
        Promise.all([MxAnimalRxAutoFormH1.load(storeRxAuto)]).then((result) => {
          Promise.all([setStoreRxAuto(storeRxAuto)]).then((result) => {
            if (row.original.txType === 'A') {
              r_dlgtable_rxs_invoice.current.setFilter(`n_invoice.inAnimal='${storeClient.inAnimal}'`);
              setDlgRxsInvoice(true);
            } else {
              navTo("animal-rx-auto-form");
            }
          });
        });
      });
    }
  }

  const openFormRxsNewAuto = async (row) => {
    setDlgRxsInvoice(false);

    if (row) {
      storeRxAuto.inInvoice = row.original.inInvoice;
      Promise.all([MxAnimalRxAutoFormH1.loadFromInvoice(storeRxAuto)]).then((result) => {
        Promise.all([setStoreRxAuto(storeRxAuto)]).then((result) => {
          navTo("animal-rx-auto-form");
        });
      });
    }
  }

  const doExportRecevet = () => {
    setDlgCreateRecevetFile(false);
    let filter = {};
    let record = {};
    record['dtRxAuto_from'] = rf_create_recevet_from.current.getVal();
    record['dtRxAuto_to'] = rf_create_recevet_to.current.getVal();
    Promise.all([FxFetch.doJsonF('rx_auto/recevet_excel_upload/precheck', filter, record)]).then((result) => {
      let rv = result[0].theValue;
      let rx = result[0].theRx;
      if (rv==='OK') {
        // Crea el excel
        Promise.all([FxFetch.doJsonF('rx_auto/recevet_excel_upload', filter, record)]).then((result) => {
          FxLog.infox('MxActivityVettR.doExportRecevet', '...result[0]:', result[0]);
          if (result[0].theFilePath) {
            let theUrl = 'https://h1.cloud.iberical.es/' + result[0].theFilePath;
            FxLog.infox('MxActivityVettR.doExportRecevet', '...theUrl:', theUrl);
            FxFile.downloadFile(theUrl);
          } else {
            r_dlg_alert.current.setValAndOpen('No hay recetas para estos criterios', null, "var(--ibs_color_red)");
          }
        });
      } else {
        // Hay cosas mal configuradas
        let errorDesc = ';'
        if (rv==='rv_no_ps_is_antibiotic') errorDesc = 'Ningún producto es de naturaleza antibiótico.';
        if (rv==='rv_missing_incorrect_rx_national_code') errorDesc = 'Falta "Código Nacional" en la ficha del Producto o es incorrecto.';
        if (rv==='rv_missing_incorrect_species') errorDesc = 'Falta "Especie" en ficha de Paciente o no está entre las aceptadas.';
        if (rv==='rv_missing_incorrect_employee_state') errorDesc = 'Falta "Provincia" en la ficha de Empleado o es incorrecta.';
        if (rv==='rv_missing_incorrect_rx_duration') errorDesc = 'Falta "Duración de Tratamiento" en la ficha del Producto o en la receta. El valor debe comenzar con un número.';
        if (rv==='rv_incorrect_rx_date') errorDesc = 'La fecha prescripción no puede ser mayor a la de hoy, ni anterior a 15 días.';
        r_dlg_alert.current.setValAndOpen(errorDesc, 'Receta: ' + rx, "var(--ibs_color_red)");
      }
    });
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;
    try{
    cols.push({ id: id++, Header: "ID", accessor: "_id", show: false });
    cols.push({ id: "inClient", Header: "inClient", accessor: "inClient", show: false });
    cols.push({ id: "inAnimal", Header: "inAnimal", accessor: "inAnimal", show: false });
    cols.push({ id: "txBranchId", Header: trans('field.branch_id'), accessor: "txBranchId", highlight: true, width: '5%', show: hasColumnBranchId() });
    cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", highlight: true, width: '20%' });
    cols.push({ id: id++, Header: trans('field.patient'), accessor: "animal_txAnimal", highlight: true, width: '10%' });

    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: id++, Header: trans('field.species'), accessor: "animal_txTypeAnimalSpecies", highlight: true, width: '10%', show: hasColumnSpecies() });
      cols.push({ id: id++, Header: trans('field.breed'), accessor: "animal_txTypeAnimalBreed", highlight: true, width: '10%', show: hasColumnBreed() });
      cols.push({ id: "dtRxAuto", Header: trans('field.date'), accessor: "dtRxAuto", highlightDate: true, width: '10%' });
      cols.push({ id: "txTypeSeriesRx", Header: trans('field.series'), accessor: "txTypeSeriesRx", highlight: true, width: '10%', show: hasColumnSeries() });
      cols.push({ id: "txRxAuto", Header: trans('field.rx'), accessor: "txRxAuto", highlight: true, width: '10%' });
      cols.push({ id: id++, Header: trans('field.ps'), accessor: "txPs", highlight: true, width: '25%' });
      cols.push({ id: id++, Header: trans('field.notes'), accessor: "txNotes", highlight: true, width: '25%' });
      cols.push({ id: id++, Header: trans('field.employee'), accessor: row => row["txEmployee"], width: '20%', show: hasColumnEmployee() });
      if (FxRegion.isSpain()) {
        cols.push({ id: id++, Header: 'Atb', accessor: row => (row["isAntibiotic"]==='1' ? trans('field.yes') : trans('field.no')), width: '10%' });
      }
      if (FxRegion.isSpain() && !FxRegion.isAndalusia()) {
        cols.push({ id: id++, Header: 'PresVet', accessor: row => (row["isAntibiotic"]==='1' ? Boolean(FxStr.isNumeric(row["txCodePresvet"])) ? trans('field.yes') : trans('field.no'): ''), width: '10%' });
      }
      
    } else { // PANTALLA PEQUEÑA
      cols.push({ id: id++, Header: trans('field.date'), accessor: row => (FxTable.cellToLocalDate(row["dtRxAuto"])), width: '10%' });
    }
    cols.push({
      id: "BTN_OPT",
      icon: <BiLockAlt style={{marginTop:'-1px'}} />, icon_alt: <BiLockOpenAlt style={{marginTop:'-1px'}} />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockedOps(!lockOps),
      accessor: row => { return getTableButtonMenu(row) },
      align: 'center', width: '33px'
    });

    cols.push({ id: "G", Header: "automatic", accessor: row => Boolean(row["inInvoice"]), show: false });
    if (FxRegion.isSpain() && !FxRegion.isAndalusia()) {
      cols.push({ id: "A", Header: "PresvetEnProceso", accessor: row => Boolean(row["txCodePresvet"].includes('PRESVET-IN-PROCESS') && !row["txCodePresvet"].includes('[')), show: false });
      cols.push({ id: "W", Header: "PresvetError", accessor: row => Boolean(row["txCodePresvet"].includes('[')), show: false });
    }

    return cols;

    } catch(error) {
      FxLog.errorx('MxActivityVettR.getTableColumns', error)
    }
    return cols;
  }

  const getTableButtonMenu = (row) => {
    let rvButton;
    let theOptions;
    theOptions = [
      { id: 'RXC', text: trans('field.clone') },
    ];
    try {
      rvButton = <CxButtonMenu
        row={row}
        onSelection={doLineOptions}
        className='ibs_iconbutton_table'
        icon={<BiDotsVerticalRounded />}
        options={theOptions}
        disabled={lockOps}
      />

    } catch (error) {
      FxLog.errorx("MxActivityVettR.getTableButtonMenu", error);
    }
    return rvButton;
  };

  const doLineOptions = (option, row) => {
    if (!option) {
      return;
    }
    try {
      // clona receta
      if (option === 'RXC') {

        // clona receta
        let record = {};
        record['txRxAuto'] = row.txRxAuto;
        record['itSeriesRx'] = row.txTypeSeriesRx;
        Promise.all([FxFetch.doJsonX('activity/vett/clone', record)]).then((result) => {
          FxLog.infox('MxActivityVettR.doLineOptions', '...rx result[0]:', result[0]);
          if (result[0]) {
            if (result[0].theValue === 'OK') {
              r_list.current.getTable().redisplay();
            }
          }
        });

      }

    } catch (error) {
      FxLog.errorx("MxActivityVettR.doLineOptions", error);
    }
  }

  const getTooltip = () => {
    let tip = `${trans('field.client')} / ${trans('field.patient')} / ${trans('field.date')} / ${trans('field.ps')} / ${trans('field.rx')}`;
    if (size.isLarge) {
      if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
      if (hasColumnSeries()) tip = tip + `${' / ' + trans('field.series')}`;
      if (hasColumnSpecies()) tip = tip + `${' / ' + trans('field.species')}`;
      if (hasColumnBreed()) tip = tip + `${' / ' + trans('field.breed')}`;
    }

    return tip;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    cols.push({ id: 'txTypeAnimalSpecies', name: trans('field.patient') + '-' + trans('field.species') + " +🔍︎", checked: hasColumnSpecies() ? '1' : '0' });
    cols.push({ id: 'txTypeAnimalBreed', name: trans('field.patient') + '-' + trans('field.breed') + " +🔍︎", checked: hasColumnBreed() ? '1' : '0' });
    cols.push({ id: 'txTypeSeriesRx', name: trans('field.series') + " +🔍︎", checked: hasColumnSeries() ? '1' : '0' });
    cols.push({ id: 'txEmployee', name: trans('field.employee') , checked: hasColumnEmployee() ? '1' : '0' });
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxActivityVettR.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    localStorage.setItem('MxActivityVettR.addcol_txTypeAnimalSpecies', options.includes('txTypeAnimalSpecies') ? '1' : '0');
    localStorage.setItem('MxActivityVettR.addcol_txTypeAnimalBreed', options.includes('txTypeAnimalBreed') ? '1' : '0');
    localStorage.setItem('MxActivityVettR.addcol_txTypeSeriesRx', options.includes('txTypeSeriesRx') ? '1' : '0');
    localStorage.setItem('MxActivityVettR.addcol_txEmployee', options.includes('txEmployee') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.activity')}: ${trans('field.rxs')}`}
        xref={r_list}
        tooltip={getTooltip()}
        fullscreen
        url={`activity/vett/typelist/r`}
        onOpenForm={openForm}
        refColors={refColors}
        columns={getTableColumns()}
        buttonAddOptions={[
          { id: 'M', text: trans('field.manual') },
          { id: 'A', text: trans('field.automatic_0') },
        ]}
        onOptions={optionsSelected}
        optionalColumns={getTableOptionalCols()}
        optionalFromTo={true}
        optionalFromToButtonToday={true}
        optionalFromToButtonLast7Days={true}
        optionalFromToButtonLast30Days={true}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <GxIconButtonLastClient theList={r_list} />

            {/* botón de Exportación Recevet (Andalucía) */}
            {FxRegion.isAndalusia() && 
              <CxIconButtonNew icon={<FaFilePrescription fontSize="19px" style={{marginTop:'1px'}} />} classType="ibs_iconbutton_toolbar" onClick={() => setDlgCreateRecevetFile(true)} tooltip={'Crear Excel para Recevet'} 
            />}
          </div>
        }
        speechExternal
      />

      <GxDlgSelectClient xref={r_dlg_select_client} 
        includeAnimal={true}
        onSelect={(row, intermediateValues) => {
          FxLog.infox('MxActivityVettR.return.GxDlgSelectClient', '...intermediateValues:', intermediateValues);
          row.original.txType = intermediateValues.txType; // para recetas
          row.original._id = intermediateValues._id; // para recetas
          row.original.txRxAuto = intermediateValues.txRxAuto; // para recetas
          row.original.itSeriesRx = intermediateValues.itSeriesRx; // para recetas
          Promise.all([setStoreClient(storeClient)]).then((result) => {
            openForm(null, row);
          });
        }} 
      />

      <CxDlgTable
        xref={r_dlgtable_rxs_invoice}
        open={dlgRxsInvoice}
        onSelect={openFormRxsNewAuto}
        onClose={() => setDlgRxsInvoice(false)}
        url={'rx_auto/invoices'}
        filter={`n_invoice.inAnimal='${storeClient.inAnimal}'`}
        columns={[
          { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtInvoice"]), width: '50%' },
          { id: "2", Header: trans('field.invoice'), accessor: "txInvoice", width: '50%' },
        ]}
        title={trans('field.invoice')}
      />

      <CxDialog
        title={'Crear fichero para Recevet'}
        open={dlgCreateRecevetFile}
        onCancel={() => setDlgCreateRecevetFile(false)}
        onOk={() => doExportRecevet()}
        height='300px'>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }} >
          <CxDate xref={rf_create_recevet_from} label={trans('field.from')} width='var(--ibs_control_width_md)' today required />
          <CxDate xref={rf_create_recevet_to} label={trans('field.to')} width='var(--ibs_control_width_md)' minDateRef={rf_create_recevet_from} today required />
        </div>
      </CxDialog>

      <CxDlgAlert xref={r_dlg_alert} />

    </div>
  );

}

export default MxActivityVettR;